<template>
  <div v-if="currentChecklist">
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="
            $router
              .push({
                name: baseUrl,
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          Liste des questions
        </button>
        <NewQuestionButton class="ml-4" :currentChecklist="currentChecklist" />
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="table-rsesponsive bg-white">
              <table class="table table-detail">
                <tbody>
                  <tr>
                    <td>
                      <i class="fa fa-info-circle text-custom-primary"></i>
                      <span class="font-weight-bold"> Nom de la checklist</span>
                    </td>
                    <td>
                      {{ currentChecklist.nom }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <i class="far fa-user text-custom-primary"></i>
                      <span class="font-weight-bold"> Auteur</span>
                    </td>
                    <td class="text-primary">
                      {{
                        currentChecklist.created_by.prenom
                          ? currentChecklist.created_by.prenom +
                            ' ' +
                            currentChecklist.created_by.nom
                          : currentChecklist.created_by.nom
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
            <div class="table-rsesponsive bg-white">
              <table class="table table-detail">
                <tbody>
                  <tr>
                    <td>
                      <i class="fa fa-info-circle text-custom-primary"></i>
                      <span class="font-weight-bold"> Statut</span>
                    </td>
                    <td>
                      <b-badge
                        variant="custom-primary"
                        pill
                        v-if="currentChecklist.statut"
                        class="p-2"
                      >
                        Oui
                      </b-badge>
                      <b-badge variant="danger" pill v-else class="p-2">
                        Non
                      </b-badge>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <Draggable
          :list="questions"
          :animation="200"
          class="list-group"
          chosenClass="cursor-move"
          dragClass="cursor-move"
          ghost-class="ghost"
        >
          <div
            class="list-group-item"
            v-for="question in questions"
            :key="question.id"
          >
            <h5 v-html="question.libelle" />
          </div>
        </Draggable>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/entretien/checklist-question';
import NewQuestionButton from '../components/NewQuestionButton.vue';
import Form from 'vform';
import { mapGetters } from 'vuex';
import Draggable from 'vuedraggable';
export default {
  data() {
    return {
      form: new Form({
        statut: false,
      }),
      questions: [],
      id: null,
    };
  },
  components: {
    NewQuestionButton,
    Draggable,
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
    baseUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.QUESTION + '/' + this.id)
        .then((resp) => {
          this.questions = Object.assign(
            [],
            window._.orderBy(resp.data.questions, ['ordre'], ['asc'])
          );
        })
        .catch();
    },
    submit() {
      this.form.item_lists = this.questions;
      this.form
        .put(URL.QUESTION)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.cursor-move {
  cursor: move;
}
.list-group-item:hover {
  cursor: move;
}

.ghost {
  opacity: 0.5;
  border: #cdac4a;
  cursor: move;
}
</style>
